module.exports = __webpack_public_path__ + "static/media/history_mapped_logo_1200x628.2e5e08ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/history_mapped_logo_1200x628.png
// module id = 599
// module chunks = 0